import { toast } from 'sonner';

/**
 * El aviso de dependencias pendientes, en **un solo lugar**.
 *
 * **Que se rompio.** El backend devuelve `warnings` cuando una tarea arranca o cierra por encima de
 * sus predecesoras. `TicketBoard` los leia y mostraba el aviso; `MyWorkPage` y `TaskPage` los
 * **tiraban** y decian "Estado actualizado". O sea: en las dos pantallas donde la gente realmente
 * trabaja se podia cerrar una tarea por encima de su predecesora y el sistema felicitaba.
 *
 * Es el patron del repo con otra cara —*el servicio hace la cosa rigurosa y la pantalla no la
 * usa*— y la forma de que no vuelva no es acordarse en tres archivos: es que haya **una** funcion
 * y que las tres la llamen. Si manana se agrega una cuarta puerta, hereda el aviso.
 *
 * Devuelve `true` si habia algo que avisar, para que quien llama decida que decir cuando no.
 */
export function avisarDependenciasPendientes(res) {
  const warnings = res?.data?.warnings || [];
  if (!warnings.length) return false;
  toast.warning(`Atencion: dependencias pendientes (${warnings.join(', ')})`, { duration: 6000 });
  return true;
}

/**
 * Lo que falta para poder empezar, en una linea para la tarjeta o la ficha.
 *
 * Viene del servidor ya resuelto (`bloqueada_por`), con el label de la predecesora y **que** exige
 * cada vinculo: un `finish_to_start` pide que termine, un `start_to_start` solo que arranque. Decir
 * "falta que termine" sobre un vinculo que no lo pide es un aviso falso.
 */
export function textoDeBloqueo(tarea) {
  const bloqueos = tarea?.bloqueada_por || [];
  if (!bloqueos.length) return '';
  return bloqueos.map(unaLineaDeBloqueo).join(' · ');
}

/**
 * Un bloqueo, en una linea.
 *
 * **Por que esta exportada.** La frase estaba escrita en tres lugares y uno la escribia a medias:
 * la tarjeta del kanban decia solo `Bloqueada: Diagnostico` y **se comia el `falta`**, que es la
 * unica parte que dice **como se destraba**. El 2026-10-02 eso hizo que la pregunta fuera
 * exactamente esa: *"no me queda claro por que sigue saliendo la leyenda, que es lo que quita el
 * bloqueo?"*. El dato venia del servidor en cada bloqueo y la pantalla lo tiraba.
 *
 * Con una sola funcion, una tarjeta nueva no puede nacer diciendo la mitad.
 */
export function unaLineaDeBloqueo(b) {
  return `${b?.label}: falta ${b?.falta}`;
}
